<style>

.tableDesign .el-input__inner{
  border: 0;
  text-align: center;
}
</style>
<template>
  <BasicLayout>
    <template #wrapper>
      <Reward ref="RewardRef" :single="true" />
      <el-tabs active-name="invitation" tab-position="left" style="background-color: #ffffff;height: 800px" @tab-click="handleTabClick">
        <el-row :gutter="10" style="margin-bottom: 10px;">
          <CommonExcel v-if="type != 'invitation'" ref="CommonExcelRef2" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" />
          <clear-cache-apply v-if="type != 'invitation'" />
          <sync-data v-if="type != 'invitation'" />
        </el-row>
        <el-tab-pane label="邀请配置" name="invitation" style="width: 60%">
          <el-card class="box-card">
            <el-form label-width="150px">
              <el-form-item label="海报刷新天数">
                <el-input v-model.number="recurrenceData.check_day" style="width: 200px" size="mini" />
                <span style="font-size: 14px;margin-left: 8px;"><i class="el-icon-warning-outline" />存在可召回状态的好友时，每N天检查刷新生成一次常规召回海报</span>
              </el-form-item>
              <el-form-item label="海报显示天数" class="inputW">
                <el-input v-model.number="recurrenceData.show_day" size="mini" />
              </el-form-item>
              <el-form-item label="奖励">
                <reward :limit-type="rlimitType" :value="recurrenceData['invitation']" />
              </el-form-item>

              <el-form-item label="邮件开关" class="send_mail">
                <el-switch
                  v-model="recurrenceData.send_mail"
                  style="display: block;margin-top: 7px;"
                  active-color="#13ce66"
                  inactive-color="#ff4949"
                  active-text="开启"
                  inactive-text="关闭"
                />
                <span style="font-size: 14px;margin-left: 8px;"><i class="el-icon-warning-outline" />开启之后将会给用户发送回归邮件</span>
              </el-form-item>

              <el-form-item label="发邮件冷却时间(天)" class="cool_time">
                <el-input v-model.number="recurrenceData.cool_time" size="mini" style="width: 140px" />
              </el-form-item>
            </el-form>
          </el-card>
          <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleDayConfig()">保存</el-button>
        </el-tab-pane>
        <el-tab-pane label="时间配置" name="day" style="width: 80%">
          <el-card class="box-card">
            <el-table class="tableDesign" size="mini" :data="recurrenceData['day']" border height="600">
              <el-table-column label="时间" align="center">
                <template slot-scope="scope">
                  <el-input v-model.number="scope.row.day" placeholder="权重" />
                </template>
              </el-table-column>
              <el-table-column label="奖励">
                <template slot-scope="scope">
                  <reward :value="scope.row.prize" />
                </template>
              </el-table-column>
              <el-table-column label="活动">
                <template slot-scope="scope">
                  <reward :exclude-cate="excludeCate" :value="scope.row.act" />
                </template>
              </el-table-column>
              <el-table-column label="分组" width="400">
                <template slot-scope="scope">
                  <el-select v-model="scope.row.gid" style="width: 400px" multiple placeholder="请选择">
                    <el-option
                      v-for="item in groups"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column label="操作">
                <template slot-scope="scope">
                  <el-button type="danger" size="mini" @click="delDay(scope.$index)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" size="mini" @click="addDay">新增</el-button>
            <el-button v-prevent-re-click type="primary" size="mini" style="margin:10px 10px" @click="handleDayConfig()">保存</el-button>
          </el-card>
        </el-tab-pane>
        <el-tab-pane label="邮件配置" name="email" style="width: 50%">
          <el-card class="box-card">
            <el-card class="box-card">
              <el-table class="tableDesign" size="mini" :data="list[typeId]" border style="width: 80%">
                <el-table-column label="序号" align="center" width="100">
                  <template slot-scope="{row,$index}">
                    <span style="display:block;" :title="row.id">{{ $index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="语言" align="center">
                  <template slot-scope="{row,$index}">
                    <el-select v-model.number="row.name" placeholder="请选择">
                      <el-option v-for="(item,idx) in lang" :key="idx" :label="item" :value="idx" />
                    </el-select>
                  </template>
                </el-table-column>
                <el-table-column label="操作" align="center">
                  <template slot-scope="{row,$index}">
                    <el-button type="primary" size="mini" @click="openDialog(row.config)">查看</el-button>
                    <el-button type="danger" size="mini" @click="handleDel($index,row.id)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <div style="float:left;margin-top: 1rem">
                <el-button type="primary" size="mini" @click="handleAdd(typeId,'',[])">新增</el-button>
                <el-button type="primary" size="mini" style="margin:10px 10px" @click="handleSaveConfig()">保存</el-button>
              </div>
            </el-card>
          </el-card>
        </el-tab-pane>
      </el-tabs>

      <el-dialog title="提示" :visible.sync="dialog" width="60%" :before-close="handleClose">
        <el-form v-if="diaLogList.length > 0" ref="form" :model="diaLogList[0]" label-width="80px">
          <el-form-item label="标题">
            <el-input v-model="diaLogList[0].title" />
          </el-form-item>
          <el-form-item label="内容">
            <MyEditor v-model="diaLogList[0].content" />
          </el-form-item>
        </el-form>
        <!--        <el-button v-permisaction="['config:advertConfig:add']" style="margin-top: 10px" type="primary" @click="dialog = false">保存</el-button>-->
      </el-dialog>
    </template>
  </BasicLayout>
</template>

<script>

import CommonExcel from '@/components/CommonExcel'
import Reward from '@/components/Reward'
import { downloadExcelMultiSheet } from '@/utils/excel'
import {
  actionComAuxiliary, comAuxiliary, delActAuxiliary, delComAuxiliary
} from '@/api/config/activity-auxiliary-cfg'
import { Message } from 'element-ui'
import ClearCacheApply from '@/components/clear_cache_apply/index.vue'
import { getCommonCfg, updateCommonCfg } from '@/api/config/common-cfg'
import SyncData from '@/components/syncData/index.vue'
import MyEditor from '@/components/Editor/index.vue'
import { getUserTypeAllList } from '@/api/config/user-group-cfg'
export default {
  name: 'Recurrence',
  components: { MyEditor, SyncData, ClearCacheApply, CommonExcel, Reward },
  data() {
    return {
      excludeCate: [100004],
      actArr: [],
      type: 'recurrenceGift',
      rlimitType: [15],
      recurrenceData: { 'invitation': [], 'day': [], check_day: 0, show_day: 0, cool_time: 0, send_mail: 0 },
      limitType: [2],
      loading: false,
      dialog: false,
      diaLogList: [],
      lang: {
        'EN': '英 文',
        'ZH': '中 文',
        'TW': '繁 体',
        'FR': '法 语',
        'DE': '德 语',
        'ES': '西班牙',
        'PT': '葡萄牙',
        'TH': '泰 语',
        'VN': '越 南',
        'NO': '挪 威',
        'ID': '印 尼',
        'IT': '意大利',
        'MY': '马来西亚',
        'RO': '罗马尼亚'
      },
      total: 0,
      list: [],
      typeId: 1,
      typeArr: { 1: '邮件配置' },
      baseList: [],
      skuList: [],
      curClass: 'recurrenceGift',
      recurrenceDayConfig: 'recurrenceDayConfig',
      groups: []
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getDayConfig()
      this.getList()
      this.getGroup()
    },
    openDialog(config) {
      this.dialog = true
      this.diaLogList = config
    },
    handleTabClick(val) {
      this.type = val.name
    },
    importCfg(updateInfo) {
      const excelData = updateInfo.data
      for (let i = 0; i < excelData.length; i++) {
        const sheet = excelData[i].sheetName
        let editFlag = false
        switch (this.type) {
          case 1:
            for (let j = 0; j < this.list[this.type].length; j++) {
              if (this.list[this.type][j].name == sheet) {
                this.list[this.type][j].config = excelData[i].sheetData
                editFlag = true
              }
            }
            if (!editFlag) {
              this.handleAdd(this.type, sheet, excelData[i].sheetData)
            }
            break

          case 'recurrenceBodyConfig':
          case 'recurrenceDayConfig':
            this.recurrenceData[this.type] = excelData[i].sheetData
            break
        }
      }
    },
    handleSaveConfig(type) {
      for (const i in this.list[4]) {
        const val = this.list[4][i]
        for (const k in val.config) {
          if (val.config[k].bet.length <= 0) {
            Message({ message: '下注不能为空', type: 'error', duration: 5 * 1000 })
            return
          }
        }
      }
      actionComAuxiliary({ class: this.curClass, list: this.list }).then(response => {
        this.msgSuccess('保存成功', () => {
          this.getList()
        }, 1000)
      })
    },
    getList() {
      this.loading = true
      comAuxiliary({ class: this.curClass, select: 0 }).then(response => {
        this.list = response.data
        for (const key in this.typeArr) {
          if (this.list[key] === undefined || this.list[key] == null) {
            this.list[key] = []
          }
        }
        this.loading = false
      })
    },
    handleDel(index, id) {
      if (id != 0) {
        delComAuxiliary({ idList: [id] })
      }
      this.list[this.typeId].splice(index, 1)
    },
    handleAdd(type, name, config) {
      const lang = this.lang[0]
      this.list[type].push({ id: 0, name: lang, class: this.curClass, type: type, config: [{ title: '', content: '' }] })
    },
    exportCfg() {
      const nameArr = []
      const dataArr = []
      switch (this.type) {
        case 'recurrenceDayConfig':
          nameArr.push('时间配置')
          dataArr.push(this.recurrenceData[this.type])
          break
        case 'recurrenceBodyConfig':
          nameArr.push('文案配置')
          dataArr.push(this.recurrenceData[this.type])
          break
        case 1:
          for (let i = 0; i < this.list[this.type].length; i++) {
            nameArr.push(this.list[this.type][i].name)
            dataArr.push(this.list[this.type][i].config)
          }
          break
      }

      this.onExport(this.type, nameArr, dataArr)
      return Promise.reject()
    },
    onExport(type, name, dataArr) {
      let fileName = ''
      const hearer = []
      const excelData = []
      let fieldMap = {}
      switch (type) {
        case 'recurrenceBodyConfig':
          fileName = '文案配置'
          fieldMap = { lang: '语言', title: '标题', body: '内容' }
          break
        case 'recurrenceDayConfig':
          fileName = '时间配置'
          fieldMap = { day: '天', prize: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}, act: { name: '活动', sub: { propsId: '道具', num: '数量', val: '附加值' }}}
          break
        case 1:
          fileName = this.typeArr[type]
          fieldMap = { mtype: '类型', sku: '库存', bet: '倍数', price: '价格', prize: { name: '奖励', sub: { propsId: '道具', num: '数量', val: '附加值' }}}
      }

      for (let i = 0; i < dataArr.length; i++) {
        const tAk = this.$refs.CommonExcelRef2.makeExcelData(dataArr[i], fieldMap)
        hearer.push(tAk[0])
        excelData.push(tAk[1])
      }

      downloadExcelMultiSheet(this.$route.meta.title + fileName, name, hearer, excelData)
    },
    addBaseConfig() {
      this.baseList.push({ minLv: 1, maxLv: 999, groupIds: [], rewardId: 0 })
    },
    deleteBaseConfig(index) {
      this.baseList.splice(index, 1)
    },
    addRewardDialogList(index) {
      this.diaLogList.push({
        title: 0,
        content: ''
      })
    },
    deleteRewardDialogList(index) {
      this.diaLogList.splice(index, 1)
    },
    handleChangePrice(row) {
      for (let i = 0; i < this.skuList.length; i++) {
        if (row.price === this.skuList[i].price) {
          row.sku = this.skuList[i].sku
          break
        }
      }
    },
    addDay(key) {
      if (!this.recurrenceData[this.type]) {
        this.recurrenceData[this.type] = []
      }
      if (key === 'body') {
        this.recurrenceData[this.type].push({ lang: '', title: '', body: '' })
      } else {
        this.recurrenceData[this.type].push({ day: 0, prize: [], act: [] })
      }
    },
    delDay(index) {
      this.recurrenceData[this.type].splice(index, 1)
    },
    handleDayConfig() {
      updateCommonCfg({ name: this.curClass, data: JSON.stringify(this.recurrenceData) }).then(res => {
        this.msgSuccess('保存成功')
      })
    },
    getDayConfig() {
      getCommonCfg({ name: this.type }).then(res => {
        console.log('res.data', res.data)
        if (res.data['day']) {
          this.recurrenceData = res.data
        }
      })
    },
    getGroup() {
      getUserTypeAllList().then(res => {
        if (res.code === 200) {
          res.data.forEach(res => {
            this.groups.push({ label: res.name, value: res.groupId })
          })
        } else {
          this.msgError(res.msg)
        }
      })
    },
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then(_ => {
          done()
        })
        .catch(_ => {})
    }
  }
}
</script>
<style scoped>
.inputW{
  width: 300px;
}
</style>
